import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './WalletContext';
import OriginalTracker from './OriginalTracker';
import MultiCoinTracker from './MultiCoinTracker';
import WalletConnector from './WalletConnector';
import SwapExecutor from './SwapExecutor';


function App() {
  return (
    <WalletProvider>
      <Router>
        <Routes>
          <Route path="/" element={<OriginalTracker />} />
          <Route path="/multi-coin" element={<MultiCoinTracker />} />
          <Route path="/wallet" element={<WalletConnector />} />
          <Route path="/swap" element={<SwapExecutor />} />
        </Routes>
      </Router>
    </WalletProvider>
  );
}

export default App;